import React from 'react'

import { PaddingProps } from 'styled-system'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import Gallery from './Gallery'
import { Container } from './styles'

type Props = PaddingProps

function NewsBoardSection({ ...rest }: Props) {
  return (
    <SectionContainer {...rest}>
      <AppearingWrapper centered>
        <Container px={LANDING_CONTENT_PX}>
          <Gallery />
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default NewsBoardSection
